import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UserProductGroup} from './user.model';
import {environment} from '../../../environments/environment';
import {BehaviorSubject, Observable, switchMap} from 'rxjs';
import {map, tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserProductGroupService {

  private userProductGroupsLoaded = false;
  private userProductGroupsSub: BehaviorSubject<UserProductGroup[]> = new BehaviorSubject([]);
  private userProductGroups$ = this.userProductGroupsSub.asObservable();

  constructor(private readonly httpClient: HttpClient) {}

  getUserProductGroups(): Observable<UserProductGroup[]> {
    if (this.userProductGroupsLoaded) {
      return this.userProductGroups$;
    }
    return this.httpClient.get<UserProductGroup[]>(`${environment.baseUrl}users/product-groups`)
      .pipe(
        tap(() => this.userProductGroupsLoaded = true),
        tap(regions => this.userProductGroupsSub.next(regions)),
      );
  }

  getUserProductGroupsForServiceRegion(serviceRegionId$: Observable<string>): Observable<UserProductGroup[]>  {
    return serviceRegionId$
      .pipe(
        switchMap(serviceRegionId => this.getUserProductGroups()
          .pipe(
            map(productGroups => {
              return productGroups.filter(productGroup => productGroup.parentOuId === serviceRegionId);
            })
          ),
        )
      );
  }
}
